import { getIsCheckedProducts } from 'common/helpers/get-is-checked-products.helper';
import { TBasketItem, TCheckedType, TProjectConfigurationGeneralItem } from 'pages/common/types';
import { TSavedProjectsComplimentaryGroup } from '../types';

export const getComplimentaryProductInfoForBasket = ({
  complementaryProducts,
  complimentaryGroups,
  checkedProducts,
}: {
  complementaryProducts: TProjectConfigurationGeneralItem[];
  complimentaryGroups: TSavedProjectsComplimentaryGroup[];
  checkedProducts: TCheckedType;
}): TBasketItem[] => {
  let result: TBasketItem[] = [];

  if (checkedProducts.length) {
    complementaryProducts.forEach(product => {
      const isProductChecked = getIsCheckedProducts({ checkedProducts, productId: product.code });
      if (isProductChecked && product.quantity > 0) {
        result.push({
          code: product.code,
          quantity: product.quantity,
        });
      }
    });

    complimentaryGroups.forEach(group => {
      const selectedProduct = group.products.find(product => product.code === group.selectedProductId);
      if (selectedProduct) {
        const isProductChecked = getIsCheckedProducts({ checkedProducts, productId: selectedProduct.code });
        if (isProductChecked && selectedProduct.quantity > 0) {
          result.push({
            code: selectedProduct.code,
            quantity: selectedProduct.quantity,
          });
        }
      }
    });
  }

  return result;
};
